// HH - Sam

// Tel Input - only allow numbers

let allTelInputs = [...document.querySelectorAll('input[type="tel"]')]

allTelInputs.forEach((input) => {
  input.addEventListener('keyup', function (e) {
    input.value = e.target.value
      .replace(/[^0-9.]/g, '')
      .replace(/(\..*?)\..*/g, '$1')
      .replace(/^0[^.]/, '0')
  })
})

const allInputs = [...document.querySelectorAll('.js-input-container input')]
// Change border color based on focus

allInputs.forEach((input) => {
  input.addEventListener('focus', function () {
    if (!input.parentElement.classList.contains('disabled')) {
      if (input.previousElementSibling) {
        input.previousElementSibling.classList.add('active')
      }

      input.parentElement.classList.add('active')
    }
  })

  if (!!input.value) {
    input.parentElement.classList.add('active')
  }
})

allInputs.forEach((input) =>
  input.addEventListener('focusout', function () {
    if (input.value === '') {
      input.parentElement.classList.remove('active')
    }
  })
)

window.handleize = function (str) {
  str = str.toLowerCase()

  var toReplace = ['"', "'", '\\', '(', ')', '[', ']']

  // For the old browsers
  for (var i = 0; i < toReplace.length; ++i) {
    str = str.replace(toReplace[i], '')
  }

  str = str.replace(/\W+/g, '-')

  if (str.charAt(str.length - 1) == '-') {
    str = str.replace(/-+\z/, '')
  }

  if (str.charAt(0) == '-') {
    str = str.replace(/\A-+/, '')
  }

  return str
}

window.__CART__CONTROLLER__ = {
  fetchingCart: null,
  async add(items = [], hidePopup, stopPopupFocus = false) {
    const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ items }),
    })

    const data = await response.json()

    if (response.ok) {

      if (!hidePopup) {
        if ( stopPopupFocus ){
          data.stopPopupFocus = stopPopupFocus
        }

        document.dispatchEvent(
          new CustomEvent('cart-popup::open', { detail: data })
        )
      }
      document.dispatchEvent(new CustomEvent('cart::add', { detail: data }))
      document.dispatchEvent(
        new CustomEvent('dlSDK::add_to_cart', { detail: data?.items[0] })
      )
    } else {
      alert(data.description)
      throw new Error(data.description)
    }

    return data
  },

  async update(updates) {
    const response = await fetch(
      window.Shopify.routes.root + 'cart/update.js',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ updates }),
      }
    )

    const data = await response.json()
    if (!response.ok) {
      alert(data.description)
      throw new Error(data.description)
    }

    return data
  },
  async get() {
    if (this.fetchingCart) {
      return this.fetchingCart.promise
    }

    try {
      this.fetchingCart = new Deferred()
      const response = await fetch(`${window.Shopify.routes.root}cart.js`, {
        headers: {
          'Content-Type': 'application/json',
        },
      })
      if (!response.ok) {
        return
      }

      const data = await response.json()
      window.__CART__ = data
      this.fetchingCart.resolve()
      this.fetchingCart = null
    } catch (error) {
      console.error(error)
    }
  },
}

document.querySelectorAll('a[href*="#cookie_settings"]').forEach((link) => {
  link.addEventListener('click', (e) => {
    e.preventDefault();
    OneTrust?.ToggleInfoDisplay();
  })
})


document.querySelectorAll('a[href*="/collections/"], a[href*="/pages/"], a[href*="/products/"], a[href*="/blogs/"]').forEach((link) => {
  const url = new URL(link.href);
  if (!url.pathname.startsWith(window.Shopify.routes.root)) {
    if (url.pathname.startsWith('/collections/')) {
      link.href = link.href.replace('/collections/', `${window.Shopify.routes.root}collections/`);
    } else if (url.pathname.startsWith('/pages/')) {
      link.href = link.href.replace('/pages/', `${window.Shopify.routes.root}pages/`);
    } else if (url.pathname.startsWith('/products/')) {
      link.href = link.href.replace('/products/', `${window.Shopify.routes.root}/products/`);
    } else if (url.pathname.startsWith('/blogs/')) {
      link.href = link.href.replace('/blogs/', `${window.Shopify.routes.root}blogs/`);
    }
  }
});
